module.exports = __webpack_public_path__ + "img/upload.b14b7a41.svg";